import * as yup from 'yup';
import i18n from 'i18n';

export const forgotPasswordSchema = yup.object().shape({
  companyEmail: yup.string()
    .email(() => i18n.t('website:auth.forgotPassword.validation.emailInvalid'))
    .required(() => i18n.t('website:auth.forgotPassword.validation.emailRequired')),
});
